import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FichaDepositoBanco;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
* Modal de edición para un FichaDepositoBanco
*/
export class FichaDepositoBancoEdit extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            IdBanco: validation.required,
            Monto: validation.required,
        };
    }

    onGuardar = () => {
        this.props.onClose(true);
    };

    onMontoChange = (monto: number) => {
        const viejo = this.props.value;
        const nuevo: Partial<Entity> = { Monto: Math.round(monto * 100) / 100 }
        this.props.onChange({ ...viejo, ...nuevo })
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const Number = getField(kea.Number);
        const Text = getField(kea.Text);
        const DateTime = getField(kea.DateTime);
        const Banco = getField(selectores.Banco);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} />]}
                onClose={this.onCerrar}
                title="Editar FichaDepositoBanco"
            >
                {kea.autogrid(6, [
                    <Banco field="IdBanco" label="Banco" />,
                    <Number field="Monto" onChange={this.onMontoChange} />,
                    <Text field="FolioFichaDeposito" label="Folio de ficha" />,
                    <Text field="Observaciones" />,
                ])}
            </kea.Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/depositobanco/edit/components/fichasdeposito/edit.tsx